<template>
  <div class="new-host-template">
    <el-row class="dialogItem">
      <span>新主播阶段:</span>
      <el-select v-model="newHostData.phase" style="width: 400px" placeholder="请选择" @input="changeDate" clearable
        multiple>
        <el-option v-for="(item, index) in hostStatus" :key="index" :label="item.name"
          :value="item.value"></el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>注册时间</span>
      <el-input v-model="newHostData.registerDays[0]" @input="changeDate"
        style="width: 180px; margin-right: 10px"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="newHostData.registerDays[1]" @input="changeDate" style="width: 180px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span> 转正时间</span>
      <el-input v-model="newHostData.positiveDays[0]" @input="changeDate"
        style="width: 180px; margin-right: 10px"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="newHostData.positiveDays[1]" @input="changeDate" style="width: 180px"></el-input>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'NewHostTemplate',
  props: {
    newHostData: {
      type: Object,
      default: () => ({
        phase: '',
        registerDays: ['', ''],
        positiveDays: ['', ''],
      })
    },
    hostStatus: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    changeDate() {
      this.$emit('changeDate')
    }
  }
}
</script>

<style scoped lang="scss">
.dialogItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  text-align: left;
  padding-left: 50px;
  color: #000;

  >span {
    width: 160px;
    margin-right: 10px;
    text-align: right;
    font-size: 15px;
    font-weight: bold;

    &.to {
      width: 50px;
      text-align: center;
    }
  }
}
</style> 